import React from "react";

import { useAuthState } from "src/features/auth";
import { changes } from "src/features/changelog/changes/content";
import { ChangelogItem } from "src/features/changelog/changes/types";
import { getRelevantChanges } from "src/features/changelog/changes/utils";

export function useRelevantChanges(): ChangelogItem[] {
	const { user } = useAuthState();
	return React.useMemo(
		() =>
			getRelevantChanges(
				changes,
				(user?.permissions ?? []).map(p => p.module)
			),
		[user]
	);
}
